/* 
Object:         Node
Description:    Logic and events for the module Node (ManageNode)
Used in:        Node
*/

import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog from "../dialog";
import * as main from "../main";
import * as navigation from "../navigation";
import * as viewmode from "../viewmode";


/**
 * Initialize form
 */
export function initializeForm(id: number): void {
    if (id > 0) {
        $("#NodeTypeId").data("kendoDropDownList").enable(false);
    }
}

/**
 * Delete item from grid
 * @param {any} e
 */
export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {

        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as NodeVM;

        // Post Data
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("Node/Delete?nodeId=" + dataItem.NodeId),
            success: function (responseData) {

                // Refresh datasource grid 
                $("#NodeGrid").data("kendoGrid").dataSource.read();

                // Do callbackJS 
                if (responseData.CallbackJS != null && responseData.CallbackJS != undefined) {
                    Function(responseData.CallbackJS)();
                    // execute callbackJS content (dont wrap more than one function call in one function as a wrapper, that will not execute)
                }

                // Show error if any
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ',
                        responseData.Message, [{
                            text: 'Ok',
                            action: function () {
                                main.closePopup();
                            }, primary: true
                        }]);
                }
            }
        });
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });

}

/**
 * Update a item from grid
 * @param {any} e
 */
export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem
    var dataItem = this.dataItem($(e.currentTarget).closest("tr")) as NodeVM;

    // Label
    var label = dataItem.Name;

    // Edit mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Node/Edit?nodeId=" + dataItem.NodeId + "&breadcrumbLabel=" + label);
}

/**
 * Show item from grid
 * @param {any} e
 */
export function showItem(e: any): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem 
    var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

    // Label
    var label = dataItem.Name;

    // Show mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Node/Show?nodeId=" + dataItem.NodeId + "&breadcrumbLabel=" + label);
}
